import { OPEN_COHORT_BASE_RESET_MODAL, CLOSE_COHORT_BASE_RESET_MODAL } from './actionTypes';

export const showConfirmCohortBaseResetModalAction = (onConfirm, onCancel, confirmationType, selectedModule) => ({
  type: OPEN_COHORT_BASE_RESET_MODAL,
  payload: {
    onConfirm,
    onCancel,
    confirmationType,
    selectedModule,
  },
});

export const hideConfirmCohortBaseResetModalAction = () => ({
  type: CLOSE_COHORT_BASE_RESET_MODAL,
});
